export const CREATE_SUGGESTED_COMPETITOR_REQUEST =
  "CREATE_SUGGESTED_COMPETITOR_REQUEST";
export const CREATE_SUGGESTED_COMPETITOR_SUCCESS =
  "CREATE_SUGGESTED_COMPETITOR_SUCCESS";
export const CREATE_SUGGESTED_COMPETITOR_FAILURE =
  "CREATE_SUGGESTED_COMPETITOR_FAILURE";

export const createSuggestedCompetitorRequest = (payload) => ({
  type: CREATE_SUGGESTED_COMPETITOR_REQUEST,
  payload,
});

export const createSuggestedCompetitorSuccess = () => ({
  type: CREATE_SUGGESTED_COMPETITOR_SUCCESS,
});

export const createSuggestedCompetitorFailure = (error) => ({
  type: CREATE_SUGGESTED_COMPETITOR_FAILURE,
  payload: error,
});
